import { filter, isNaN, join, parseInt, split } from "lodash";

export default function onlyNumbers(input: string): string {
  const arr = filter(split(input, ""), num => {
    return !isNaN(parseInt(num));
  });

  return join(arr, "");
}
